import { Link } from 'react-router-dom';
import { MAPS_URL } from '../../lib/businessInfo';

export default function ServiceAreaStickyBar() {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden"
      style={{
        paddingBottom: 'max(env(safe-area-inset-bottom), 16px)',
        WebkitTapHighlightColor: 'transparent',
      }}
    >
      <div className="bg-gradient-to-t from-black/95 via-black/90 to-transparent pt-6 pb-4 px-4">
        <div className="flex items-center gap-3 max-w-md mx-auto">
          <Link
            to="/inventory"
            className="flex-1 bg-gray-900 hover:bg-gray-800 text-white font-bold py-4 px-6 rounded-full text-center transition-all duration-200 active:scale-95 whitespace-nowrap shadow-lg"
          >
            View Inventory
          </Link>
          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-gray-900 font-bold py-4 px-6 rounded-full text-center transition-all duration-200 active:scale-95 whitespace-nowrap shadow-lg"
          >
            Get Directions
          </a>
        </div>
      </div>
    </div>
  );
}
